import { getGiveawayDetailUser, getShowItemGiveaway, updateShowItemGiveaway } from 'functions/redux/giveaway/action';
import { RootStore } from 'functions/redux/store';
import moment from 'moment';

import React, { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux'
import ButtonPrimary from 'shared/Button/ButtonPrimary';

export default function ListGiveaway() {
    const dispatch = useDispatch();
    const { user, giveawayReducer } = useSelector((state: RootStore) => state);
    const [loadingBtn, setLoadingBtn] = useState(false);

    useEffect(() => {
        if (giveawayReducer.giveawayDetailUser == null) {
            dispatch(getGiveawayDetailUser())
        }
    }, [user, giveawayReducer.giveawayDetailUser])


    const loadMore = async () => {
        setLoadingBtn(true);
        updateShowItemGiveaway(getShowItemGiveaway() + 1)
        await dispatch(getGiveawayDetailUser(getShowItemGiveaway(), giveawayReducer.giveawayDetailUser))
        setLoadingBtn(false);

    }

    return (
        <>
            {giveawayReducer?.giveawayDetailUser == null ? (
                <div className="flex justify-center mb-10 h-96 items-center">
                    <Loader
                        type="Circles"
                        color="#D24D29"
                        height={25}
                        width={25}
                    />
                </div>
            ) : giveawayReducer?.giveawayDetailUser?.map((val: any, index: any) => {
                let url = '/giveaway?q=' + val.giveaway.slug;
                return (
                    <div key={index} className={` mt-3 nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow p-2 `}>
                        <a className="cursor-pointer" href={url} target='_blank' rel="noreferrer" onClick={() => {
                        }}>
                            <div className="flex flex-row" >
                                <div className="flex flex-col ml-2 py-2 text-left ">

                                    <div>
                                        <h4 style={{ fontSize: 16, whiteSpace: 'pre-line', lineBreak: 'anywhere' }} className="mr-2 font-semibold line-clamp-2" >{val.giveaway.name}</h4>
                                        <div className="">
                                            <span className="">{val.giveaway.description}</span>
                                        </div>
                                        <span>{moment(val.giveaway.startDate).format('LL')} - {moment(val.giveaway.endDate).format('LL')}</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                )
            })}
            <div className='mt-5'>
                <ButtonPrimary className="w-full" onClick={() => {
                    loadMore();
                }}> {loadingBtn ? (
                    <Loader
                        type="Circles"
                        color="white"
                        height={20}
                        width={20}
                    />
                ) : 'Load more'}</ButtonPrimary>
            </div>
        </>
    )
}
